import { Exclude, Expose, Type } from 'class-transformer';
import { ApiProperty } from '@nestjs/swagger';
import { JobArchivedSheetInterface } from '../interfaces/job-archived-sheet.interface';
import { BuilderInterface } from 'src/modules/builder/interfaces/builder.interface';
import { JobPhaseInterface } from 'src/modules/job-phase/interfaces/job-phase.interface';
import { JobInterface } from 'src/modules/job/interfaces/job.interface';
import { RegionInterface } from 'src/modules/region/interfaces/region.interface';

@Exclude()
export class JobArchivedSheetDto implements JobArchivedSheetInterface {
  job?: JobInterface | undefined;
  region?: RegionInterface | undefined;
  builder?: BuilderInterface | undefined;
  jobPhase?: JobPhaseInterface | undefined;

  //
  // Job fields
  //
  @ApiProperty({ title: 'Job ID' })
  @Expose()
  jobId!: string;

  @ApiProperty({ title: 'Job Phase ID' })
  @Expose()
  jobPhaseId!: string;

  @ApiProperty({ title: 'Job Lot' })
  @Expose()
  jobLot!: string;

  @ApiProperty({ title: 'Job Block' })
  @Expose()
  jobBlock!: string;

  @ApiProperty({ type: 'string', title: 'Address' })
  @Expose()
  address1!: string | null;

  //
  // Subdivision fields
  //
  @ApiProperty({ title: 'Subdivision ID' })
  @Expose()
  subdivisionId!: string;

  @ApiProperty({ title: 'Subdivision Name' })
  @Expose()
  subdivisionName!: string;

  //
  // Builder fields
  //
  @ApiProperty({ title: 'Builder ID' })
  @Expose()
  builderId!: string;

  @ApiProperty({ title: 'Builder Name' })
  @Expose()
  builderName!: string;

  //
  // Region fields
  //
  @ApiProperty({ title: 'Region ID' })
  @Expose()
  regionId!: string;

  //
  // Supervisor fields
  //
  @ApiProperty({ title: 'Supervisor User IDs' })
  @Expose()
  supervisorUserIds!: string;

  @ApiProperty({ title: 'Supervisor Full Names' })
  @Expose()
  supervisorFullNames!: string;

  //
  // Job archive tracking
  //
  @ApiProperty({ type: 'date-time', title: 'Last Event At' })
  @Expose()
  @Type(() => Date)
  lastEventAt!: Date | null;

  @ApiProperty({ type: 'date-time', title: 'Archived At' })
  @Expose()
  @Type(() => Date)
  archivedAt!: Date | null;

  @ApiProperty({ type: 'date-time', title: 'PO Signed At' })
  @Expose()
  @Type(() => Date)
  poSignedAt!: Date | null;

  //
  // Misc fields
  //
  @ApiProperty({ title: 'Phase Structure Type' })
  @Expose()
  phaseStructureType!: string;

  //
  // Purchase order fields
  //
  @ApiProperty({
    type: 'string',
    title: 'Purchase Order #',
    description:
      'Number of the earliest purchase order by creation date; null when the job has none',
  })
  @Expose()
  purchaseOrderNumber!: string | null;

  @ApiProperty({
    title: 'Purchase Order Count',
    description: 'How many purchase orders the job has; 0 when it has none',
  })
  @Expose()
  purchaseOrderCount!: number;

  @ApiProperty({
    type: 'string',
    title: 'Purchase Order #s',
    description:
      'Every purchase order number on the job in creation order, comma separated; null when it has none',
  })
  @Expose()
  purchaseOrderNumbers!: string | null;
}
